import type { Settings } from '../game/types';

const KEY = 'bq-stormbreakers:v1';
export const DEFAULT_SETTINGS: Settings = {
  locale: 'zh', quality: 'standard', volume: 0.55, bestScores: {}, tutorialDone: false,
};
export function loadSettings(storage?: Pick<Storage, 'getItem'>): Settings {
  try {
    const raw = (storage ?? window.localStorage).getItem(KEY);
    if (!raw) return structuredClone(DEFAULT_SETTINGS);
    const record: unknown = JSON.parse(raw);
    if (!record || typeof record !== 'object') return structuredClone(DEFAULT_SETTINGS);
    const saved = record as Record<string, unknown>;
    if (saved.version !== 1) return structuredClone(DEFAULT_SETTINGS);
    const bestScores: Record<string, number> = {};
    if (saved.bestScores && typeof saved.bestScores === 'object') {
      for (const [key, value] of Object.entries(saved.bestScores)) {
        if (/^(open|islands|fortress):(easy|normal|hard):(sloop|frigate|galleon)$/.test(key) &&
            typeof value === 'number' && Number.isFinite(value) && value >= 0) bestScores[key] = value;
      }
    }
    return {
      locale: saved.locale === 'en' ? 'en' : 'zh',
      quality: saved.quality === 'low' ? 'low' : 'standard',
      volume: typeof saved.volume === 'number' && Number.isFinite(saved.volume) ? Math.max(0, Math.min(1, saved.volume)) : 0.55,
      tutorialDone: saved.tutorialDone === true, bestScores,
    };
  } catch { return structuredClone(DEFAULT_SETTINGS); }
}
export function saveSettings(settings: Settings, storage?: Pick<Storage, 'setItem'>): boolean {
  try { (storage ?? window.localStorage).setItem(KEY, JSON.stringify({ version: 1, ...settings })); return true; }
  catch { return false; }
}
